<app-message-header></app-message-header>
<div class="section">

	<!-- Side nav bar -->
	<div class="inner-container">
        <div style="padding-top: 20px;overflow-x: scroll;">
 <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 150%;">
    <ng-container matColumnDef="resellerName">
        <th id="appl" mat-header-cell *matHeaderCellDef>Reseller Name</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">   
               <div style="padding-top: 15px;" class="font-weight-bold">{{element.company}}</div> 
        </td>
    </ng-container>

    <ng-container matColumnDef="todayscount">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth1}} {{year1}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">   
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentTodayCount !=='' && element.sentTodayCount !== null && element.sentTodayCount !== undefined"><br/> Sx - {{element.sentTodayCount}} <br/><br/> Rx -  {{element.receiveTodayCount}} 
                    </div>
                     <img *ngIf="element.sentTodayCount ==='' || element.sentTodayCount === null || element.sentTodayCount === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
                </div>
               
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="previousmonth1count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth2}} {{year}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth1Count !=='' && element.sentPreviousMonth1Count !== null && element.sentPreviousMonth1Count !== undefined"><br/> Sx - {{element.sentPreviousMonth1Count}} <br/><br/> Rx -  {{element.receivePreviousMonth1Count}}  
                    </div>
                    <img *ngIf="element.sentPreviousMonth1Count ==='' || element.sentPreviousMonth1Count === null || element.sentPreviousMonth1Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <ng-container matColumnDef="previousmonth2count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth3}} {{year2}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth2Count !=='' && element.sentPreviousMonth2Count !== null && element.sentPreviousMonth2Count !== undefined"><br/> Sx - {{element.sentPreviousMonth2Count}} <br/><br/> Rx -  {{element.receivePreviousMonth2Count}}</div>
                    <img *ngIf="element.sentPreviousMonth2Count ==='' || element.sentPreviousMonth2Count === null || element.sentPreviousMonth2Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth3count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth4}} {{year3}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth3Count !=='' && element.sentPreviousMonth3Count !== null && element.sentPreviousMonth3Count !== undefined"><br/> Sx - {{element.sentPreviousMonth3Count}} <br/><br/> Rx -  {{element.receivePreviousMonth3Count}}</div>
                    <img *ngIf="element.sentPreviousMonth3Count ==='' || element.sentPreviousMonth3Count === null || element.sentPreviousMonth3Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth4count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth5}} {{year4}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth4Count !=='' && element.sentPreviousMonth4Count !== null && element.sentPreviousMonth4Count !== undefined"><br/> Sx - {{element.sentPreviousMonth4Count}} <br/><br/> Rx -  {{element.receivePreviousMonth4Count}}</div>
                    <img *ngIf="element.sentPreviousMonth4Count ==='' || element.sentPreviousMonth4Count === null || element.sentPreviousMonth4Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <ng-container matColumnDef="previousmonth5count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth6}} {{year5}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth5Count !=='' && element.sentPreviousMonth5Count !== null && element.sentPreviousMonth5Count !== undefined"><br/> Sx - {{element.sentPreviousMonth5Count}} <br/><br/> Rx -  {{element.receivePreviousMonth5Count}}</div>
                    <img *ngIf="element.sentPreviousMonth5Count ==='' || element.sentPreviousMonth5Count === null || element.sentPreviousMonth5Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <ng-container matColumnDef="previousmonth6count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth7}} {{year6}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth6Count !=='' && element.sentPreviousMonth6Count !== null && element.sentPreviousMonth6Count !== undefined"><br/> Sx - {{element.sentPreviousMonth6Count}} <br/><br/> Rx -  {{element.receivePreviousMonth6Count}}</div>
                    <img *ngIf="element.sentPreviousMonth6Count ==='' || element.sentPreviousMonth6Count === null || element.sentPreviousMonth6Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <ng-container matColumnDef="previousmonth7count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth8}} {{year7}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth7Count !=='' && element.sentPreviousMonth7Count !== null && element.sentPreviousMonth7Count !== undefined"><br/> Sx - {{element.sentPreviousMonth7Count}} <br/><br/> Rx -  {{element.receivePreviousMonth7Count}}</div>
                    <img *ngIf="element.sentPreviousMonth7Count ==='' || element.sentPreviousMonth7Count === null || element.sentPreviousMonth7Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth8count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth9}} {{year8}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth8Count !=='' && element.sentPreviousMonth8Count !== null && element.sentPreviousMonth8Count !== undefined"><br/> Sx - {{element.sentPreviousMonth8Count}} <br/><br/> Rx -  {{element.receivePreviousMonth8Count}}</div>
                    <img *ngIf="element.sentPreviousMonth8Count ==='' || element.sentPreviousMonth8Count === null || element.sentPreviousMonth8Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <ng-container matColumnDef="previousmonth9count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth10}} {{year9}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth9Count !=='' && element.sentPreviousMonth9Count !== null && element.sentPreviousMonth9Count !== undefined"><br/> Sx - {{element.sentPreviousMonth9Count}} <br/><br/> Rx -  {{element.receivePreviousMonth9Count}}</div>
                    <img *ngIf="element.sentPreviousMonth9Count ==='' || element.sentPreviousMonth9Count === null || element.sentPreviousMonth9Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth10count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth11}} {{year10}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth10Count !=='' && element.sentPreviousMonth10Count !== null && element.sentPreviousMonth10Count !== undefined"><br/> Sx - {{element.sentPreviousMonth10Count}} <br/><br/> Rx -  {{element.receivePreviousMonth10Count}}</div>
                    <img *ngIf="element.sentPreviousMonth10Count ==='' || element.sentPreviousMonth10Count === null || element.sentPreviousMonth10Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth11count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth12}} {{year11}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth11Count !=='' && element.sentPreviousMonth11Count !== null && element.sentPreviousMonth11Count !== undefined"><br/> Sx - {{element.sentPreviousMonth11Count}} <br/><br/> Rx -  {{element.receivePreviousMonth11Count}}</div>
                    <img *ngIf="element.sentPreviousMonth11Count ==='' || element.sentPreviousMonth11Count === null || element.sentPreviousMonth11Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="previousmonth12count">
        <th id="appl" mat-header-cell *matHeaderCellDef>{{formattedMonth13}} {{year12}}</th>
        <td id="applData" class="widthSize" mat-cell *matCellDef="let element">    
               <div class="spn1">
                <div class="span2">                
                    <div *ngIf="element.sentPreviousMonth12Count !=='' && element.sentPreviousMonth12Count !== null && element.sentPreviousMonth12Count !== undefined"><br/> Sx - {{element.sentPreviousMonth12Count}} <br/><br/> Rx -  {{element.receivePreviousMonth12Count}}</div>
                    <img *ngIf="element.receivePreviousMonth12Count ==='' || element.receivePreviousMonth12Count === null || element.receivePreviousMonth12Count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;"> 
                </div>
            </div>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<img  *ngIf="pageLoader" src="assets/images/uib-loading-500x500.gif"  alt="Page Loader" class="imageLoader" style="margin-bottom: 300px;"/>
<app-pagination [collectionSize]="paginationCount" [pageSize]="5" [(page)]="page" [maxSize]="3" [disabled]="paginationDisabled" (pageChange)="pageChanged2($event)"></app-pagination>
</div>
</div>
</div>